import { Typography } from "antd";
import { useLocation } from 'react-router-dom';
import { routes } from "../constants";

function PathHeader() {
  const location = useLocation();

  return (
    <Typography>
      {routes[location.pathname]?.title || location.pathname}
    </Typography>
  );
}

export default PathHeader;
